import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/Devices.css";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import { LoadShortDate } from "../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../functions/LoadShortTime.js";
import Device from "./Device/Device.jsx";
import NewDevice from "./NewDevice.jsx";
import { AppContext } from "../../../AppProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar.jsx";
import { DeviceContext } from "./DeviceProvider.jsx";
import { useNavigate } from "react-router-dom";
function DevicesTable({devicesSummary,access_token,selectedServerUrl,logout,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage}){
    const[showDeviceComponent,setShowDeviceComponent] = useState(false);
    const[devicesSortType,setDevicesSortType] = useState('name-ascending');
    const[deviceId,setDeviceId] = useState(null);
    const deviceIdRef = useRef();
    useEffect(() => {
        deviceIdRef.current = deviceId;
    },[deviceId]);
    if(!Array.isArray(devicesSummary) || devicesSummary.length === 0) return(
        
            <div className="tenant-administrator-loading-devices-mask">
                <div className="tenant-administrator-loading-devices-mask-spinner"></div>
                <p>Loading devices, please wait...</p>
            </div>
    );
    return(
        <div className="tenant-administrator-devices-table-container">
            <table className="tenant-administrator-devices-table">
                <thead>
                    <tr id="tenant-administrator-devices-table-header-row">
                        <th onClick={() =>{
                            if(devicesSortType === 'name-ascending') setDevicesSortType('name-descending');
                            else setDevicesSortType('name-ascending');
                        }}>Name</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'date-time-created-ascending') setDevicesSortType('date-time-created-descending');
                            else setDevicesSortType('date-time-created-ascending');
                        }}>Date created</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'date-time-created-ascending') setDevicesSortType('date-time-created-descending');
                            else setDevicesSortType('date-time-created-ascending');
                        }}>Time created</th>
                        <th>Subscription</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'status-ascending') setDevicesSortType('status-descending');
                            else setDevicesSortType('status-ascending');
                        }}>Status</th>
                        <th onClick={() =>{
                            if(devicesSortType === 'customer-ascending') setDevicesSortType('customer-descending');
                            else setDevicesSortType('customer-ascending');
                        }}>Customer</th>
                    </tr>
                </thead>
                <tbody>
                    {[...devicesSummary].sort((a,b) =>{
                        if(devicesSortType === 'name-ascending') return a?.name?.localeCompare(b?.name);
                        else if(devicesSortType === 'name-descending') return b?.name?.localeCompare(a?.name);
                        else if(devicesSortType === 'status-ascending') return (a?.active? 'Active':'Inactive').localeCompare(b?.active? 'Active':'Inactive');
                        else if(devicesSortType === 'status-descending') return (b?.active? 'Active':'Inactive').localeCompare(a?.active? 'Active':'Inactive');
                        else if(devicesSortType === 'customer-ascending') return a?.customerName?.localeCompare(b?.customerName);
                        else if(devicesSortType === 'customer-descending') return b?.customerName?.localeCompare(a?.customerName);
                        else if(devicesSortType === 'date-time-created-ascending') return a?.createdTime - b?.createdTime;
                        else if(devicesSortType === 'date-time-created-descending') return b?.createdTime - a?.createdTime;
                    }).map(deviceSummary => {
                        return (
                            <tr onClick={async () =>{
                                setDeviceId(deviceSummary.id);
                                setShowDeviceComponent(true);
                            }} key={deviceSummary.id}>
                                <td>{deviceSummary.name}</td>
                                <td>{LoadShortDate(deviceSummary.createdTime)}</td>
                                <td>{LoadShortTime(deviceSummary.createdTime)}</td>
                                <td style={{color:`${deviceSummary?.subscription === 'ACTIVE'? 'green':deviceSummary?.subscription === 'GRACE'? 'orange':'red'}`}}>
                                    {deviceSummary?.subscription === 'ACTIVE'? 'Active':deviceSummary?.subscription === 'GRACE'? 'Grace':'Inactive'}
                                </td>
                                <td style={{color:`${deviceSummary.active? 'green':'red'}`}}>{deviceSummary.active? 'Active':'Inactive'}</td>
                                <td>{deviceSummary.customerName || '_'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <Device
                deviceId={deviceId}
                deviceIdRef={deviceIdRef}
                setDeviceId={setDeviceId}
                selectedServerUrl={selectedServerUrl}
                access_token={access_token}
                showDeviceComponent={showDeviceComponent}
                setShowDeviceComponent={setShowDeviceComponent}
                logout={logout}
                setShowBottomRightMessageBox={setShowBottomRightMessageBox}
                setBottomRightMessageBoxMessage={setBottomRightMessageBoxMessage}
            />
        </div>
    );
}
const Devices = () =>{
    const {user,logout,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage} = useContext(AppContext);
    const [devicesSummary,setDevicesSummary] = useState([]);
    const [tenantAdminProfiles,setTenantAdminProfiles] = useState([]);
    const [tenantAdminProfilesFetched,setTenantAdminProfilesFetched] = useState(false);
    const [devicesFetched,setDevicesFetched] = useState(false);
    const [showNewDeviceWindow,setShowNewDeviceWindow] = useState(false);
    const {selectedTenantAdminProfile,setSelectedTenantAdminProfile} = useContext(DeviceContext);
    const [selectedServerUrl,setSelectedServerUrl] = useState("select");
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setTenantAdminProfiles(responseData);
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving tenant administrator profiles from the server:',error);
        }
        setTenantAdminProfilesFetched(true);
    };
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices?limit=50`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving devices from the server:',error);
        }
    };
    useEffect(() =>{
        if(tenantAdminProfilesFetched) return;
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        fetchServerProfiles();
    },[user,tenantAdminProfilesFetched]);
    useEffect(() =>{
        if(selectedTenantAdminProfile && !devicesFetched){
            setDevicesSummary([]);
        }
    },[devicesFetched,selectedTenantAdminProfile]);
    useEffect(() =>{
        if(selectedTenantAdminProfile && !devicesFetched && Array.isArray(devicesSummary) && devicesSummary.length === 0){
            fetchDevicesSummary();
            setDevicesFetched(true);
        }
    },[devicesSummary]);
    useEffect(() =>{
        if(Array.isArray(tenantAdminProfiles)){
            tenantAdminProfiles.forEach(profile =>{
                if(profile?.defaultProfile) setSelectedTenantAdminProfile(profile);
            });
        }
    },[tenantAdminProfiles]);
    return(
        <div className="tenant-administrator-devices-page">
            <NavigationBar/>
            <div className="tenant-administrator-devices-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="tenant-administrator-devices-parent-container">
                    <div className="tenant-administrator-devices-container">
                        <div className="tenant-administrator-devices-header-container">
                            <h2>Devices</h2>
                            <div className="tenant-administrator-devices-header-controls">
                                <select
                                    className="tenant-administrator-server-url-select"
                                    onChange={(e) => {
                                        setSelectedTenantAdminProfile(tenantAdminProfiles.find(profile => profile?.id === e.target.value));
                                        setDevicesFetched(false);
                                    }}
                                    value={selectedTenantAdminProfile? selectedTenantAdminProfile?.id:'select'}
                                >
                                    <option value="select" disabled>Server connection</option>
                                    {tenantAdminProfiles.map((serverProfile,index) => (
                                        <option key={index} value={serverProfile?.id}>{serverProfile?.profileName}</option>
                                    ))}
                                </select>
                                <button className="tenant-administrator-add-new-device-button" onClick={() => {setShowNewDeviceWindow(true)}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                </button>
                                <button className="tenant-administrator-refresh-devices-button" onClick={() => fetchDevicesSummary()}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<DevicesTable
                            devicesSummary={devicesSummary}
                            access_token={user?.access_token}
                            selectedServerUrl={selectedServerUrl}
                            logout={logout}
                            setShowBottomRightMessageBox={setShowBottomRightMessageBox}
                            setBottomRightMessageBoxMessage={setBottomRightMessageBoxMessage}
                        />}
                        {<NewDevice
                            showNewDeviceWindow={showNewDeviceWindow}
                            setShowNewDeviceWindow={setShowNewDeviceWindow}
                            accessToken={user?.access_token}
                            serverUrl={selectedServerUrl}/>}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Devices;